import { component } from 'picoapp'
import '@/lib/jquery-global.js';

export default component((node, ctx) => {
  
    // $(window).load(function() {
    //     var h = $('#promo').outerHeight();
    //     jQuery(node).height(h);
    // })

    

})
